<template>
  <div class="wrap">

    <Head />
    <div class="part1">
      <p class="p1">
        寻找与众不同的你
      </p>
    </div>
    <div class="part2">
      <p class="tit1">我们的福利</p>
      <div class="centent">
        <div class="card">
          <img
            src="../../assets/images/mobile/joinUs/part2-1.png"
            alt=""
          >
          <p>五险一金</p>
        </div>
        <div class="card">
          <img
            src="../../assets/images/mobile/joinUs/part2-2.png"
            alt=""
          >
          <p>法定假期</p>
        </div>

        <div class="card">
          <img
            src="../../assets/images/mobile/joinUs/part2-3.png"
            alt=""
          >
          <p>周末双休</p>
        </div>
        <div class="card">
          <img
            src="../../assets/images/mobile/joinUs/part2-4.png"
            alt=""
          >
          <p>带薪年假</p>
        </div>
        <div class="card">
          <img
            src="../../assets/images/mobile/joinUs/part2-5.png"
            alt=""
          >
          <p>定期团建</p>
        </div>
        <div class="card">
          <img
            src="../../assets/images/mobile/joinUs/part2-6.png"
            alt=""
          >
          <p>生日福利</p>
        </div>
        <div class="card">
          <img
            src="../../assets/images/mobile/joinUs/part2-7.png"
            alt=""
          >
          <p>定期体检</p>
        </div>
        <div class="card">
          <img
            src="../../assets/images/mobile/joinUs/part2-8.png"
            alt=""
          >
          <p>节日福利</p>
        </div>
        <div class="card">
          <img
            src="../../assets/images/mobile/joinUs/part2-9.png"
            alt=""
          >
          <p>年终奖金</p>
        </div>
      </div>
    </div>

    <div class="part3" v-if="list && list.length>0">
      <p class="tit1">人才招聘</p>
      <div class="swipe">
        <van-swipe indicator-color="white">
          <van-swipe-item
            v-for="item in list"
            :key="item.id"
          >
            <div class="card">
              <p class="title">{{item.nameCn}}</p>
              <div
                v-html="item.contentCn"
                class="text"
              >

              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/mobile/Head.vue";
import Foot from "../../components/mobile/Foot.vue";
import api from "../../common/api";
import { Timeline, TimelineItem } from "iview";
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
Vue.use(Swipe).use(SwipeItem);
export default {
  data() {
    return {
      isCN: true,
      list: [],
    };
  },
  components: {
    Head,
    Foot,
    Timeline,
    TimelineItem,
  },
  created() {
    this.getLang();
    this.getInfo();
  },
  methods: {
    getLang() {
      //   this.isCN=localStorage.getItem('Lang')=='cn'?true:false;
      this.isCN = this.$i18n.locale == "cn" ? true : false;
    },
    getInfo() {
      this.$axios
        .get(api.getJoinInfo)
        .then((res) => {
          if (res.data.list && res.data.list.length > 0) {
            this.list = res.data.list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);
  width: vw(750);
  bg(url('../../assets/images/mobile/joinUs/part1.png'));
  overflow: hidden;
  margin-top: vw(98);

  .p1 {
    font-size: vw(40);
    color: rgba(255, 255, 255, 1);
    line-height: vw(40);
    margin-top: vw(127);
    text-align: center;
  }
}

.part2 {
  part();
  padding: vw(80) vw(12) vw(50);
  background: #fff;

  .tit1 {
    tit3();
    margin-bottom: vw(32);
  }

  .centent {
    display: flex;
    flex-wrap: wrap;

    .card {
      width: vw(209);
      margin: 0 vw(16) vw(18);

      img {
        width: vw(209);
        height: auto;
      }

      p {
        color: rgba(68, 68, 68, 1);
        font-size: vw(28);
        line-height: vw(28);
        text-align: center;
      }
    }
  }
}

.part3 {
  part();
  background-color: rgba(245, 245, 245, 1);
  padding-bottom: vw(50);

  .tit1 {
    tit3();
    margin-bottom: vw(70);
  }

  .card {
    width: vw(690);
    height: vw(900);
    margin: 0 auto vw(100);
    overflow-y: auto;
    background: #fff;
    padding: vw(60) vw(40);

    .title {
      font-size: vw(32);
      font-weight: bold;
      color: #333;
      line-height: vw(32);
      margin-bottom: vw(20);
    }

    .text {
      font-size: vw(28);
      line-height: vw(40);
      color: #444;
      font-weight: 400;
    }
  }

  .swipe {
    /deep/.van-swipe { // 滑动底部导航
      .van-swipe__indicators {
        .van-swipe__indicator {
          width: vw(16);
          height: vw(16);
          background-color: transparent;
          border: 1px solid #2A93FF;
          opacity: 1;
        }

        .van-swipe__indicator--active {
          background: #2A93FF !important;
        }
      }
    }
  }
}
</style>
